import { logErrorDebug } from '../debug/debugLogging'

export function getSafeLocalStorageItem(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    logErrorDebug('getSafeLocalStorageItem', 'error accessing localStorage')
    return null
  }
}

export function setSafeLocalStorageItem(key: string, value: string) {
  try {
    localStorage.setItem(key, value)
  } catch (e) {
    logErrorDebug('setSafeLocalStorageItem', 'error accessing localStorage')
  }
}